export const TagIcon: React.FC<React.ComponentProps<"svg">> = ({
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7 6C6.44772 6 6 6.44772 6 7C6 7.55228 6.44772 8 7 8C7.54871 8 8.01 7.5529 8.01 7C8.01 6.4471 7.54871 6 7 6Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 1C1.44772 1 1 1.44772 1 2V12C1 12.2654 1.10552 12.5199 1.29331 12.7075L9.88271 21.2869C11.0372 22.4424 12.9731 22.442 14.1275 21.2867L21.2992 14.115C22.4464 12.961 22.4464 11.039 21.2992 9.885L12.7071 1.29289C12.5196 1.10536 12.2652 1 12 1H2ZM19.8817 12.7041L12.7125 19.8733C12.3266 20.2596 11.6827 20.2571 11.2967 19.8725L3 11.5854V3H11.5858L19.8808 11.295C20.2625 11.6795 20.2632 12.3193 19.8817 12.7041Z"
        fill="currentColor"
      />
    </svg>
  );
};
